import { IComponentOptions } from 'angular';
import { VariableSpecimenComponent } from '../variable-specimen/variable-specimen';
import template from './variable-specimen-2.html';

export const VariableSpecimen2ComponentOptions: IComponentOptions = {
    controller: VariableSpecimenComponent,
    bindings: {
        font: '<',
        text: '@',
    },
    template: template,
};
